import { useAppSelector } from '../../app/hooks';
import type { CurrentUser } from '../../lib/apiTypes';

interface AuthContext {
  currentUser: CurrentUser | null;
  isAuthenticated: boolean;
  isAdmin: boolean;
  status: 'idle' | 'loading' | 'authenticated' | 'forbidden' | 'error';
  errorMessage: string | null;
}

/** Convenience accessor for the current authenticated user session. */
export function useAuth(): AuthContext {
  const { currentUser, status, errorMessage } = useAppSelector((s) => s.auth);
  return {
    currentUser,
    isAuthenticated: status === 'authenticated' && currentUser !== null,
    isAdmin: currentUser?.isAdmin ?? false,
    status,
    errorMessage,
  };
}
